import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { CourseTypeFormValues } from 'src/models/CourseType.model';

type Props = {
    formikProps: FormikProps<CourseTypeFormValues>;
    onClose: () => void;
    formType: string;
};

const CourseType = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    {formType === "ADD" ? "Add Course Type" : "Update Course Type"}{" "}
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='courseType'
                        required
                        value={values.courseType}
                        onChange={(e) => {
                            setFieldValue('courseType', e.target.value);
                        }}
                        label='Course Type'
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default CourseType;